import PropTypes from 'prop-types';

export const Product = PropTypes.shape({
  shopify_url: PropTypes.string,
  title: PropTypes.string,
  occurrence: PropTypes.instanceOf(Date),
  image_url: PropTypes.string,
  mindate: PropTypes.number,
});

export const Theme = PropTypes.shape({
  textColor: PropTypes.string,
  backgroundColor: PropTypes.string,
});

export const ReservationTranslation = PropTypes.shape({
  bookingNotReserved: PropTypes.string,
  updateReservation: PropTypes.string,
  reservationExpired: PropTypes.string,
  success: PropTypes.string,
});

export const ReservationSetting = PropTypes.shape({
  mode: PropTypes.string,
  position: PropTypes.string,
  reservation_expiry_minutes: PropTypes.number,
  when_expired: PropTypes.number,
});

export const WidgetSetting = PropTypes.oneOfType([ReservationSetting]);

export const DefaultSetting = PropTypes.shape({
  theme: PropTypes.instanceOf(Theme),
  style: PropTypes.object,
  translation: PropTypes.oneOfType([ReservationTranslation]),
  configuration: PropTypes.oneOfType([ReservationSetting]),
});

export default {
  Product,
};
